import { render, staticRenderFns } from "./ads-sample-dialog.vue?vue&type=template&id=63078580&"
import script from "./ads-sample-dialog.vue?vue&type=script&lang=js&"
export * from "./ads-sample-dialog.vue?vue&type=script&lang=js&"
import style0 from "./ads-sample-dialog.vue?vue&type=style&index=0&id=63078580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports